import debounce from './directive-debounce'
const install = function(Vue) {
  Vue.directive('debounce', debounce)
}
if (window.Vue) {
  Vue.use(install); // eslint-disable-line
}
export default install


// WEBPACK FOOTER //
// ./src/directive/index.js